import {useTrustAccountPermissions} from '@/features/trust-accounts/providers';

/** Whether any buyer-creation affordance applies here — see `useAddBuyerTarget` for which one. */
export function useCanCreateBuyer(): boolean {
  return useTrustAccountPermissions().canCreateBuyer;
}
